import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { TabButtons as CoreTabButtons, ITabButtonsProps } from 'core-components/library/tabButtons'

export const TabButtons = (props: ITabButtonsProps) => {
  return (
    <CoreTabButtons {...props} titleRender={(text) => <Translation text={text || ''} span />} />
  )
}
